module.exports = __webpack_public_path__ + "static/img/cMRId1.f6a0e51b.png";